module.exports = __webpack_public_path__ + "img/carousel-img-3@2x.ddb616bc.jpg";